import BulkInsertDispatcher from './bulk_insert'
import Session from './session'
import EditDispatcher from './edit'
import PresentationEvents from './presentation_events'
import CloseWindowDispatcher from './close_window'
import PlaceholderPreload from './placeholder_preload'
import AskForFeedback from './ask_for_feedback'
import store from '@polleverywhere/redux'
import { slice as appSlice } from '../../slices/app'

export default async (app) => {
  // Similar to capacitor dispathers not loading if you're not in that env
  // maybe we can check if we're in the apps?
  const { mode } = store.getState()[appSlice.name]
  if (mode !== 'integration') {
    return
  }

  Session(app)
  AskForFeedback(app)
  CloseWindowDispatcher(app)
  BulkInsertDispatcher(app)
  EditDispatcher(app)
  PresentationEvents(app)
  PlaceholderPreload(app)
}
